<template>
  <div class="vuse-content-wrapper">
    <div v-if="hasAccess('task')">
      <vuse-section-definition
        v-show="!hideTitle"
        :title="page"
        icon="work"
      ></vuse-section-definition>
      <v-container fluid class="">
        <v-row>
          <v-col cols="12" lg="3" md="3" sm="34"
            ><v-text-field
              v-model="filter.SearchTerm"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              solo
              hide-details
            ></v-text-field
          ></v-col>
          <v-col cols="12" lg="3" md="3" sm="3">
            <client-select
              v-model="filter.clientId"
              append-icon="mdi-magnify"
              label="Client"
              solo
              :hide-details="true"
            />
          </v-col>
          <v-col cols="12" lg="3" md="3" sm="3">
            <TaskStatusSelect
              label="Filter by Status"
              v-model="filter.status"
              hide-details
              solo
            />
          </v-col>
          <v-col cols="12" lg="3" md="3" sm="3">
            <TagsSelect
              v-model="filter.tags"
              label="Filter by Tags"
              hide-details
              solo
              clearable
              multiple
              dense
            />
          </v-col>

          <v-col cols="12" class="text-right">
            <v-btn
              color="info"
              dark
              class="mb-2"
              @click="onAdd()"
              v-show="hasAccess('task.add')"
            >
              Add Job
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
          <v-card>
            <v-skeleton-loader
              v-if="isLoading"
              class="mx-auto"
              type="table"
            ></v-skeleton-loader>
            <v-data-table
              v-else
              :headers="activeHeaders"
              :items="sortedDataItems"
              :loading="loading"
              class="elevation-1"
              :item-class="coloringRow"
              :options.sync="tableOptions"
              :server-items-length="totalItems"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100, 200],
              }"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        rounded
                        class="content-ma-0 mr-2"
                        v-on="on"
                        x-small
                      >
                        <v-icon small>menu</v-icon> Customize Columns
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item
                        dense
                        :key="i"
                        v-for="(header, i) in headers"
                      >
                        <v-list-item-title v-if="header.readonly">
                          <v-checkbox
                            v-model="headers[i].active"
                            :label="header.text"
                            :disabled="true"
                          />
                        </v-list-item-title>
                        <v-list-item-title v-else>
                          <v-checkbox
                            v-model="headers[i].active"
                            :label="header.text"
                          />
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-toolbar>
              </template>

              <template v-slot:item.lastUpdated="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      @click="onOpen(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.lastUpdated | formatDatetime }}
                    </v-chip>
                  </template>
                  <span>{{ momentLocal(item.lastUpdated).fromNow() }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.dateCreated="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      @click="onOpen(item)"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.dateCreated | formatDatetime }}
                    </v-chip>
                  </template>
                  <span>{{ momentLocal(item.dateCreated).fromNow() }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.date="{ item }">
                <v-chip small @click="onOpen(item)">
                  {{ item.date | formatDate }}
                </v-chip>
              </template>

              <template v-slot:item.description="{ item }">
                <DescriptionDialog :text="item.description" />
              </template>

              <template v-slot:item.userId="{ item }">
                <span @click="onOpen(item)">
                  <UsersChip :value="item.taskUsers" />
                </span>
              </template>

              <template v-slot:item.clientCompanyName="{ item }">
                <span @click="onOpen(item)">
                  <ClientChip
                    :clientId="item.clientId"
                    :clientName="item.clientCompanyName"
                  />
                </span>
              </template>

              <template v-slot:item.timeClock="{ item }">
                <span @click="onTimeEntryForm(item)">
                  <TimeclockClocking v-if="item" :item="item" />
                  <div class="text-center" v-else>-</div>
                </span>
              </template>

              <template v-slot:item.status="{ item }">
                <span @click="onOpen(item)"
                  ><TaskStatusChip :status="item.status"
                /></span>
              </template>

              <template v-slot:item.name="{ item }">
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  @click="onOpen(item)"
                  :title="item.name"
                >
                  {{ item.name }}
                </div>
                <div
                  v-else
                  style="min-width: 50ch"
                  @click="onOpen(item)"
                  :title="item.name"
                >
                  {{ item.name }}
                </div>
              </template>

              <template v-slot:item.type="{ item }" @click="onOpen(item)">
                <span @click="onOpen(item)">
                  <TypeChip :value="item.type" />
                </span>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn-toggle
                  borderless
                  background-color="transparent"
                  class="d-flex"
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn small icon class="content-ma-0 mr-2" v-on="on">
                        <v-icon>mdi-cogs</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="onOpen(item)"
                        v-show="hasAccess('task.edit')"
                      >
                        <v-list-item-title>
                          <v-icon small left>mdi-pencil</v-icon>Edit
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="onOpen(item)"
                        v-show="!hasAccess('task.edit') && hasAccess('task.view')"
                      >
                        <v-list-item-title>
                          <v-icon small left>work</v-icon>View
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        @click="onDelete(item)"
                        v-show="hasAccess('task.delete')"
                      >
                        <v-list-item-title>
                          <v-icon small left>delete</v-icon>Delete
                        </v-list-item-title>
                      </v-list-item>

                      <!-- <v-list-item
                      @click="onAttachFile(item)"
                      v-show="hasAccess('task.delete')"
                    >
                      <v-list-item-title>
                        <v-icon small left>mdi-file</v-icon>View Files
                      </v-list-item-title>
                    </v-list-item> -->
                    </v-list>
                  </v-menu>

                  <!-- <v-btn small v-if="item.invoiceId" @click="goToInvoice(item)">
                    #{{ item.invoiceId }}
                  </v-btn>

                  <v-btn small v-if="item.quoteId" @click="goToQuote(item)">
                    #{{ item.quoteId }}
                  </v-btn> -->

                  <TimeclockAction
                    :parentItem="item"
                    v-show="
                      (['open', 'inprogress'].includes(item.status) &&
                      hasAccess('timeClock.complete'))
                    "
                    :showStart="false"
                    :showStop="false"
                    @onUpdate="refresh()"
                  />
                </v-btn-toggle>
              </template>
            </v-data-table>
          </v-card>
         </v-col>
        </v-row>
      </v-container>

      <task-form
        :show="showForm"
        :clientId="clientId"
        :item="selectedItem"
        @onClosed="clearAdd()"
        @onSucceded="refresh()"
      ></task-form>

      <TaskTimeClock
        :show="showTimeClock"
        :clientId="clientId"
        :item="selectedItem"
        @onClosed="clearMakeTimeClock()"
        @onSucceded="refresh()"
      ></TaskTimeClock>

      <TimeClockEntryForm
        :show="showTimeEntryForm"
        :item="selectedItem"
        :client-id="clientId"
        @onClosed="clearTimeEntryForm()"
      />

      <delete-dialog
        :show="showDelete"
        :item="selectedItem"
        @onClosed="clearDelete()"
        @onSucceded="refresh()"
      />

      <AttachedFileListDialog
        :show="showAttachFile"
        :item="selectedItem"
        object="task"
        @onClosed="clearAttachFile()"
        @onSucceded="refresh()"
      />
    </div>

    <NoPermission v-else />
  </div>
</template>

<script>
import DeleteDialog from "./Task/_Delete";
import TaskForm from "./Task/_FormJob";
import TaskTimeClock from "./Task/_FormTimeClock";
import { mapActions, mapState, mapGetters } from "vuex";
import formatterMixin from "@/mixins/formatterMixin";
import TaskStatusChip from "src/components/TaskStatusChip";
import TaskStatusSelect from "components/TaskStatusSelect";
import TimeclockClocking from "./Timeclock/__TimeclockClocking";
import TimeclockAction from "./Timeclock/__TimeclockAction";
import TagsSelect from "components/TagSelect";
import UsersChip from "components/UsersChip";
import ClientChip from "components/ClientChip";
import TypeChip from "components/TypeChip";
import TimeClockEntryForm from "./_TimeClockEntry";
import _ from "lodash";
import { getStorage, setStorage } from "src/utils/helpers";
import AttachedFileListDialog from "components/FilesAttachment/TaskAttachedFileListDialog";
import ClientSelect from "components/ClientSelect.vue";
import DescriptionDialog from "components/DescriptionDialog";
import NoPermission from "components/NoPermission";

const SETTING_LIST_KEY = "taskList-columns";
const defaultHeaders = [
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
  },
  {
    text: "Job Code",
    value: "code",
    sortable: true,
    active: true,
    width: "10%",
  },
  { text: "Name", value: "name", sortable: true, active: true, width: "10%" },
  {
    text: "Clients",
    align: "start",
    sortable: true,
    value: "clientCompanyName",
    active: true,
  },
  { text: "Files", value: "totalFiles", active: true, sortable: true },
  { text: "Assigned To", value: "userId", active: true, sortable: false },
  {
    text: "Description",
    value: "description",
    active: true,
    sortable: true,
  },
  { text: "Status", value: "status", active: true },
  { text: "Type", value: "type", active: true },
  {
    text: "Time Clock",
    value: "timeClock",
    active: true,
    sortable: true,
  },
  { text: "Creation Date", value: "date", active: true },
  {
    text: "Date Created",
    value: "dateCreated",
    sortable: true,
    active: false,
  },
  {
    text: "Date Modified",
    value: "lastUpdated",
    sortable: true,
    active: false,
  },
];
export default {
  mixins: [formatterMixin],
  props: {
    clientId: Number,
    hideTitle: Boolean,
  },

  components: {
    TimeClockEntryForm,
    TaskForm,
    DeleteDialog,
    TaskStatusChip,
    TaskTimeClock,
    TimeclockClocking,
    TimeclockAction,
    TaskStatusSelect,
    TagsSelect,
    UsersChip,
    ClientChip,
    TypeChip,
    AttachedFileListDialog,
    ClientSelect,
    DescriptionDialog,
    NoPermission,
  },
  data: () => ({
    isEdit: false,
    valid: false,
    namespace: "Tasks",
    page: "Jobs",
    usage: "usage",

    tableOptions: {},

    clients: [],
    users: [],
    statuses: [
      { id: 1, name: "open" },
      { id: 2, name: "closed" },
    ],

    filter: {
      SearchTerm: "",
      clientId: "",
      status: "",
      isTimeClockRunning: null,
      hideCompleted: null,
      isInvoiced: false,
      tags: [],
    },

    menu: false,

    keyword: "",
    headers: defaultHeaders.map((item) => {
      let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
      let nowHeader = savedHeaders.filter(
        (saved) => saved.value === item.value
      );

      if (nowHeader) {
        nowHeader = nowHeader[0];
      }
      return {
        ...item,
        ...nowHeader,
      };
    }),
    tasks: [],
    editedItem: {
      id: null,
      clientId: "",
      userId: "",
      user: "",
      name: "",
      type: "",
      description: "",
      status: "",
      date: "",
    },

    showForm: false,
    showDelete: false,
    showTimeClock: false,
    showTimeEntryForm: false,
    showAttachFile: false,
    selectedItem: {},
  }),
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      task: (state) => state.task,
      account: (state) => state.account.data.user,
      loading: (state) => state.task.loadingTable,
      totalItems: (state) => state.task.metaData.totalEntries,
    }),

    isLoading() {
      return this.loading && this.dataItems.length == 0;
    },

    computedFilter() {
      let {
        clientId,
        tags,
        status,
        isTimeClockRunning,
        SearchTerm,
        isInvoiced,
      } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };

      params.OrderBy =
        sortBy.length > 0 && sortBy[0] ? sortBy[0] : "dateCreated";

      if (sortDesc.length > 0) {
        params.Ascending = !sortDesc[0];
      } else {
        params.Ascending = false;
      }

      if (isTimeClockRunning !== null) {
        params.isTimeClockRunning = isTimeClockRunning;
      }

      if (status) {
        params.status = status;
        if (status == "invoiced") {
          // only show invoiced task
          isInvoiced = true;
        }
      }

      if (isInvoiced === false || isInvoiced === true) {
        params.isInvoiced = isInvoiced;
      }

      if (clientId) {
        params.clientId = clientId;
      }

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }

      if (tags && tags.length > 0) {
        params.tagsArray = [];
        tags.map((tag) => {
          params.tagsArray.push(tag);
        });
      }

      return params;
    },

    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },

    sortedDataItems() {
      // 1. running first
      // 2. open
      // 3. latest modified
      let dataItems = [...this.dataItems];
      if (this.hideCompleted) {
        dataItems = dataItems.filter(
          (item) => item.status != "completed" && item.isCompleted == false
        );
      }

      if (!this.hasAccess('task.view')) {        
        dataItems = dataItems.filter(item => {
          let userIds = item.taskUsers.map(user => user.userId);
          return userIds.includes(this.account.id);
        });      
      }

      return dataItems;
    },

    dataItems() {
      return this.$store.getters["task/getAll"];
    },

    getClientId() {
      const { clientId } = this.$route.params;
      if (clientId) {
        return parseInt(clientId);
      }
      if (this.clientId) {
        return this.clientId;
      }
      return false;
    },

    isAutoAdd() {
      return this.optional(this.$route.query, "action", "") === "add-task";
    },
    tags() {
      return this.filter.tags;
    },
  },
  watch: {
    tags() {
      this.taskSearch(this.filter);
    },
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },
    tableOptions: {
      handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          this.refresh();
        }
      },
      deep: true,
    },

    filter: {
      async handler() {
        await this.refresh(true);
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.clientId) {
      this.filter.clientId = this.clientId;
    }
    await this.refresh();

    this.timer = setInterval(() => {
      this.refreshNoLoading();
    }, (60 * 1000));

    if (this.isAutoAdd) {
      this.onAdd();
    }
  },

  beforeDestroy() {
    if (this.clientId) {
      this.clearTableFilter();
    }
    clearInterval(this.timer);
    this.$store.dispatch("task/clearData");
  },

  methods: {
    ...mapActions("task", ["getAll", "clearTableFilter", "applyTableFilter"]),
    ...mapActions({
      taskClearAll: "task/clearAll",
      taskDelete: "task/delete",
      taskSearch: "task/search",
    }),

    checkDescriptionLength(item) {
      return (
        item.description.length > 200 || item.description.split("\n").length > 3
      );
    },
    coloringRow() {
      return "";
    },

    goToInvoice(item) {
      this.$router.push(`/invoices/${item.invoiceId}/edit`);
    },

    goToQuote(item) {
      this.$router.push(`/bids/${item.quoteId}/edit`);
    },

    refresh: _.debounce(async function () {
      this.refreshTable(true);
    }, 500),

    async refreshTable(noLoading = true) {
      this.applyTableFilter({ ...this.computedFilter, noLoading });
    },

    async refreshNoLoading() {
      if (!this.loading) {
        await this.refreshTable(false);
      }
    },

    onAdd() {
      this.showForm = true;
      this.selectedItem = {};
    },

    onMakeTimeClock(item) {
      this.showTimeClock = true;
      this.selectedItem = item;
    },

    clearMakeTimeClock() {
      this.showTimeClock = false;
      this.selectedItem = {};
    },

    onTimeEntryForm(item) {
      this.showTimeEntryForm = true;
      this.selectedItem = item;
    },

    async clearTimeEntryForm() {
      this.showTimeEntryForm = false;
      this.selectedItem = {};
      await this.refresh();
    },

    onOpen(item) {
      if (!this.hasAccess("task.edit") && !this.hasAccess("task.view")) {
        return false;
      }
      this.showForm = true;
      this.selectedItem = item;
    },

    onAttachFile(item) {
      this.showAttachFile = true;
      this.selectedItem = item;
    },

    clearAdd() {
      this.showForm = false;
      this.selectedItem = {};
    },

    clearDelete() {
      this.showDelete = false;
      this.selectedItem = {};
    },

    clearAttachFile() {
      this.showAttachFile = false;
      this.selectedItem = {};
    },

    onDelete(item) {
      this.showDelete = true;
      this.selectedItem = item;
    },

    async deleteItemConfirm() {
      await this.taskDelete(this.editedItem.id);
      this.refresh();
    },
  },
};
</script>
